import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  Input,
  signal,
  DestroyRef
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QRCodeComponent } from 'angularx-qrcode';
import { TranslateService } from 'i18n';
import { ENVIRONMENT, Logger, Platform, clipboardCopy } from 'shared';

@Component({
    selector: 'app-install',
    templateUrl: './app-install.component.html',
    styleUrls: ['./app-install.component.scss'],
    imports: [CommonModule, QRCodeComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppInstallComponent implements OnInit {

  googlePlayLink = signal<string>('');
  appleStoreLink = signal<string>('');
  imagesLoaded: boolean = false;
  // qrLink = `${environment.serverUrl}/link/app-store?ngsw-bypass`;
  qrLink = `${this.environment.serverUrl}/link/app-store`; // excluded in ngsw-config.js

  @Input()  token: string | undefined;
  @Output() onClose: EventEmitter<void> = new EventEmitter();
  @Output() onLink:  EventEmitter<any>  = new EventEmitter();

  protected logger = new Logger('AppInstallComponent');

  constructor(public platform: Platform,
              private changeDetector: ChangeDetectorRef,
              private destroyRef: DestroyRef,
              private translateService: TranslateService,
              @Inject(ENVIRONMENT) private environment: any) {
    //this.logger.debug('AppInstallComponent.ctor()');
  }

  onTapLink(event: MouseEvent): void {
    // if (this.token && this.platform.is('mobile')) {
    //   // make token available to eventually installed app
    //   clipboardCopy(this.token).catch((error: any) => this.logger.error("Failed to copy to clipboard"));
    // }
    this.onLink.emit((event.target as HTMLAnchorElement).href);
    // event.preventDefault();
  }

  onTapClose(event: MouseEvent) {
    this.onClose.emit();
  }

  imageLoaded(event:Event) {
    window.setTimeout(() => {
      this.imagesLoaded = true;
      // markForCheck() call is required when the component is displayed inside bottom sheet.
      // In this case the change detection does no happen automatically.
      // When used inside a regular overlay it works also without the following line.
      this.changeDetector.markForCheck();
    }, 5000);
    if (event.target instanceof HTMLElement) {
      (event.target as HTMLElement).style.opacity = "1";
    }
  }

  ngOnInit() {
    this.translateService
        .translateAsync('app.install.link.google')
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          this.googlePlayLink.set(result)
        });
    this.translateService
      .translateAsync('app.install.link.apple')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.appleStoreLink.set(result)
      });
  }

  get androidOrDesktop(): boolean {
    return this.platform.is('desktop') || this.android;
  }

  get android(): boolean {
    return !this.platform.is('hybrid') && this.platform.is('android');
  }

  get iosOrDesktop(): boolean {
    return this.platform.is('desktop') || (!this.platform.is('hybrid') && this.platform.is('ios'))
  }
}
